export default "__VITE_ASSET__f24c2a80__"